import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';

import { isEmptyObject, capitalize} from '../../libraries/utils';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';

import PharmacyCard from '../../components/customs/PharmacyCard';
import MedicamentCartElement from '../../components/customs/MedicamentCartElement';

import Icon from '../../libraries/icons';

class PurchaseCart extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      renderHistory: true,
      prescriptions: [],
      pharmacy: null,
      medicaments: [],
      prescription_medicaments: [],
    }
  }
  
  componentDidMount() {
    if (!isEmptyObject(this.props.location.state)) { 
      //add presciptions list to state, despues ver como separar los meds
      let { pharmacy, prescriptions, medicaments, from } = this.props.location.state;
      if(!medicaments){
        medicaments = []
      }
      if(!prescriptions){
        prescriptions = []
      }
      this.setState({ pharmacy, prescriptions, medicaments, from } );
      this.getMedicamentsFromPrescriptions(prescriptions)
      console.log("STATE", pharmacy, prescriptions, medicaments, from)
    }
  }

  changeMedicamentQuantity = (id,quantity) => {
    const medicaments = this.state.medicaments.map(m => {
        if(m.id === id){
          m.autoFocus = true 
          return {...m, quantity: quantity}
        } else {
          m.autoFocus = false
          return m
        }
      }
    )
    this.setState({ medicaments })
  }

  removeMedicament = (id) => {
    const medicaments = this.state.medicaments.filter(m => m.id !== id)
    this.setState({ medicaments })
  }

  getMedicamentsFromPrescriptions = (prescriptions) => {
    let prescription_medicaments = []
    prescriptions.forEach(prescription => {
      if(prescription.prescriptions_lines){
        prescription.prescriptions_lines.forEach(line => {
          if(prescription_medicaments.some(m => m.target_id === line.target_id)){
            prescription_medicaments = prescription_medicaments.map(m => {
              if(m.target_id === line.target_id){
                m.quantity += line.quantity
              }
              return m
            })
          } else {
            const l = {...line}
            prescription_medicaments = [...prescription_medicaments, l]
          }
        })
      }
    })
    this.setState({ prescription_medicaments })
  }

  selectPharmacy = () =>{
    const { medicaments, pharmacy, prescriptions } = this.state;
    history.push({
      pathname: config.ROUTES.PHARMACIES,
      state: {
        medicaments,
        pharmacy,
        prescriptions,
        fromCart: true
      }
    })
  }

  addMedicaments = ()=>{
    const { medicaments, pharmacy, prescriptions } = this.state;
    history.push({
      pathname: config.ROUTES.PURCHASES.SEARCH,
      state: {
        medicaments,
        pharmacy,
        prescriptions,
      }
    })
  }

  gotoBack = () => {
    const { from } = this.state
    history.push(from ? from : config.ROUTES.HOME)
  }  

  gotoNext = () => {
    this.setState({ renderHistory: false })
    const { medicaments, pharmacy, prescriptions } = this.state;
    console.log('GO NEXT', medicaments, pharmacy, prescriptions);
    history.push({
      pathname: config.ROUTES.PURCHASES.REVIEW,
      state: {
        medicaments,
        pharmacy,
        prescriptions
      }
    })
  }  

  goPharmacy = () => {
    const { pharmacy, prescriptions, medicaments } = this.state;
    history.push({
      pathname: config.ROUTES.PHARMACIES,
      state: {
        medicaments,
        pharmacy,
        prescriptions,
        fromCart: true
      }
    })
  }

  render(){
    const { pharmacy, prescriptions, medicaments, prescription_medicaments, renderHistory } = this.state;
    return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: this.t("Enviar receta"),
          className: "flex justify-between p-3",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          {pharmacy ? (
            <PharmacyCard
              onClick={() => this.goPharmacy(pharmacy)}
              pharmacy={pharmacy}
            />
          ) : (
            <Button
              className="btn-primary btn-outline btn-xs mx-auto mt-2"
              title={this.t("Seleccionar farmacia")}
              onClick={this.selectPharmacy}
            />
          )}
          <div className="flex justify-between mb-4 mt-5">  
            <h2>{this.t("Pedido")}</h2>
            <Button
              className="btn-primary btn-outline btn-xs"
              title={this.t("Agregar Productos")}
              onClick={this.addMedicaments}
            />
          </div>
          <div>
            { prescriptions && prescription_medicaments.map((line, index) =>{ 
              const medicament = line.json_data.medicament
              return(
                <MedicamentCartElement
                  key={index} 
                  className="border-b py-2"
                  medicament={medicament} 
                  prescription={true}
                />
              )
            })}
            { medicaments && medicaments.map((medicament, index) =>{ 
              return(
                <MedicamentCartElement
                  key={index} 
                  className="border-b py-2"
                  medicament={medicament} 
                  onChangeQuantity={(id, q) => {this.changeMedicamentQuantity(id,q)}}
                  onRemove={(id) => {this.removeMedicament(id)}} 
                  editable={true}
                />
              )
            })}
          </div>
          <Button
            className="btn-primary btn-block mt-10"
            title={"Confirmar Pedido"}
            onClick={ this.gotoNext }
            disabled={ (!pharmacy || (medicaments.length === 0 && prescription_medicaments.length === 0))  }
          />
        </section>
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    purchases: state.purchases.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PurchaseCart));

